(() => {
  const SELECTOR = '[data-custom-capsule-quantity-selector-v1]';

  function parseMoney(text) {
    const value = String(text || '').trim();

    const match = value.match(/^(.*?)([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/);

    if (!match) return null;

    return {
      prefix: match[1],
      amount: parseFloat(match[2].replace(/,/g, '')),
      suffix: match[3]
    };
  }

  function formatMoney(amount, money) {
    if (!money) return amount.toFixed(2);

    return (
      money.prefix +
      amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) +
      money.suffix
    );
  }

  function init(root) {
    if (!root || root.dataset.cqsInitialized === 'true') return;

    root.dataset.cqsInitialized = 'true';

    const formId = root.dataset.productFormId;
    const form = document.getElementById(formId);

    if (!form) return;

    const options = Array.from(
      root.querySelectorAll('[data-cqs-option]')
    );

    if (!options.length) return;

    /*
     * Capture the original single-unit price from
     * Broadcast's native Add to Cart button.
     */
    const mainPriceElement =
      form.querySelector('[data-product-price]') ||
      document.querySelector(
        '.product__submit [data-product-price]'
      );

    const originalMoney = parseMoney(
      mainPriceElement?.textContent
    );

    if (!originalMoney || !Number.isFinite(originalMoney.amount)) {
      console.warn(
        'RHYA Capsule selector: unable to determine base product price.'
      );
      return;
    }

    const unitPrice = originalMoney.amount;

    /*
     * Actual Shopify discount is handled in Shopify Admin.
     * This percentage is only used for PDP price display.
     */
    const DUO_DISCOUNT = 15;

    function getQuantityInput() {
      let input = form.querySelector('[name="quantity"]');

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        form.appendChild(input);
      }

      return input;
    }

    function getPricing(quantity) {
      const compareTotal = unitPrice * quantity;

      let finalTotal = compareTotal;

      if (quantity === 2) {
        finalTotal = compareTotal * (1 - DUO_DISCOUNT / 100);
      }

      return {
        finalTotal,
        compareTotal
      };
    }

    function priceHTML(quantity) {
      const pricing = getPricing(quantity);

      const finalPrice = formatMoney(
        pricing.finalTotal,
        originalMoney
      );

      const comparePrice = formatMoney(
        pricing.compareTotal,
        originalMoney
      );

      if (quantity === 2 && pricing.finalTotal < pricing.compareTotal) {
        return `
          <span class="custom-atc-final-price">${finalPrice}</span>
          <span
            class="custom-atc-compare-price"
            style="
              text-decoration: line-through;
              opacity: .65;
              margin-left: 6px;
            "
          >${comparePrice}</span>
        `;
      }

      return `
        <span class="custom-atc-final-price">${finalPrice}</span>
      `;
    }

    function updatePrices(quantity) {
      const html = priceHTML(quantity);

      /*
       * Main native Add to Cart button
       */
      document
        .querySelectorAll(
          `#${CSS.escape(formId)} [data-product-price]`
        )
        .forEach((element) => {
          element.innerHTML = html;
        });

      /*
       * Sticky Broadcast cart bar
       */
      const productInfo = root.closest('product-info');

      if (productInfo) {
        productInfo
          .querySelectorAll('.cart-bar [data-product-price]')
          .forEach((element) => {
            element.innerHTML = html;
          });
      }
    }

    function selectOption(button) {
      const quantity = Number(button.dataset.quantity || 1);

      options.forEach((option) => {
        const selected = option === button;

        option.classList.toggle('is-selected', selected);
        option.setAttribute(
          'aria-checked',
          selected ? 'true' : 'false'
        );

        option.tabIndex = selected ? 0 : -1;
      });

      root.dataset.selectedQuantity = String(quantity);

      /*
       * Update Broadcast native product form
       */
      const quantityInput = getQuantityInput();

      quantityInput.value = String(quantity);

      quantityInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

      /*
       * Update main + sticky displayed prices
       */
      updatePrices(quantity);
    }

    options.forEach((button) => {
      button.addEventListener('click', () => {
        selectOption(button);
      });
    });

    /*
     * Ensure correct quantity immediately before
     * Broadcast submits its native form.
     */
    form.addEventListener(
      'submit',
      () => {
        const quantity = Number(
          root.dataset.selectedQuantity || 1
        );

        getQuantityInput().value = String(quantity);
      },
      true
    );

    const defaultQuantity =
      Number(root.dataset.defaultQuantity || 1);

    const initial =
      options.find(
        (option) =>
          Number(option.dataset.quantity) === defaultQuantity
      ) || options[0];

    selectOption(initial);
  }

  function initAll(scope = document) {
    if (scope.matches?.(SELECTOR)) {
      init(scope);
    }

    scope
      .querySelectorAll?.(SELECTOR)
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll()
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => initAll(event.target)
  );
})();